// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1fyLe","inner":"Footer_inner__10Lp9","nextIcon":"Footer_nextIcon__368k6","innerLeft":"Footer_innerLeft__3itZ0"};